import React from 'react';
import { motion } from 'framer-motion';
import { FaCode, FaPaintBrush, FaStar } from 'react-icons/fa';
import ScrollReveal from './ScrollReveal';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

const AboutSection = () => {
  const features = [
    {
      icon: <FaCode className="text-3xl text-secondary" />,
      title: 'פיתוח מתקדם',
      description: 'שימוש בAI וטכנולוגיות חדשניות לבניית אתרים מהירים ויציבים'
    },
    {
      icon: <FaPaintBrush className="text-3xl text-secondary" />,
      title: 'עיצוב מודרני',
      description: 'עיצוב מותאם אישית שמשקף את זהות העסק'
    },
    {
      icon: <FaStar className="text-3xl text-secondary" />,
      title: 'תוצאות מוכחות',
      description: 'לקוחות מרוצים וממליצים שרואים תוצאות'
    }
  ];

  const FeatureCard = ({ feature }) => (
    <motion.div
      whileHover={{ y: window.innerWidth >= 640 ? -8 : 0 }}
      className="p-6 sm:p-8 h-full min-h-[250px]"
    >
      <div className="flex flex-col items-center text-center h-full">
        <motion.div
          whileHover={{ rotate: 360 }}
          transition={{ duration: 0.6 }}
          className="w-16 h-16 flex items-center justify-center mb-6"
        >
          {feature.icon}
        </motion.div>
        <h3 className="text-xl font-semibold text-white mb-4">
          {feature.title}
        </h3>
        <p className="text-gray-300">
          {feature.description}
        </p>
      </div>
    </motion.div>
  );

  return (
    <section id="about" className="relative -mt-2 sm:-mt-16">
      <div className="container mx-auto px-4 relative z-10">
        {/* Mobile View (Swiper) */}
        <div className="sm:hidden">
          <Swiper
            modules={[Pagination, Autoplay]}
            spaceBetween={20}
            slidesPerView={1}
            pagination={{ 
              clickable: true,
              bulletClass: 'swiper-pagination-bullet custom-bullet',
              bulletActiveClass: 'swiper-pagination-bullet-active custom-bullet-active'
            }}
            autoplay={{
              delay: 2000,
              disableOnInteraction: false,
            }}
          >
            {features.map((feature, index) => (
              <SwiperSlide key={index}>
                <FeatureCard feature={feature} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {/* Desktop View (Grid) */}
                  <div className="hidden sm:grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {features.map((feature, index) => (
              <ScrollReveal key={index} delay={index * 0.1}>
                <FeatureCard feature={feature} />
              </ScrollReveal>
            ))}
          </div>
      </div>
    </section>
  );
};

export default AboutSection; 